import React from 'react'

export default function SpotSnapMyGifts() {
  return (
    <div>SpotSnapMyGifts</div>
  )
}
